import MobileMenu from './mobile-menu'
import DesktopMenu from './desktop-menu'
import { NAVIGATION_BREAKPOINT } from '../../utils/constants'

/**
 * Manages init/tear down of different menu modes depending on viewport width.
 */
const Header = (function () {
  // Available menu modes/UI versions of main nav component
  const navModes = {
    mobile: 'mobile',
    desktop: 'desktop',
  }

  let mediaQuery = window.matchMedia(`(min-width: ${NAVIGATION_BREAKPOINT})`)
  let curNavMode
  let curNavComponent

  const initViewportSizeListener = () => {
    if (mediaQuery?.addEventListener) {
      mediaQuery.addEventListener('change', handleViewportChange)
    } else {
      mediaQuery.addListener(handleViewportChange) // Safari <14 doesn't support addEventListener so have added fallback. Can eventually look to remove as we drop support for older versions. https://stackoverflow.com/questions/62693995/addeventlistener-is-not-a-function-for-matchmedia-in-safari-browser
    }
  }

  /**
   * Handles switching between different menu UIs based on viewport width media query
   */
  const handleViewportChange = () => {
    let newMode = mediaQuery.matches ? navModes.desktop : navModes.mobile

    if (newMode !== curNavMode) {
      killNavComponent()

      if (newMode === navModes.mobile) {
        curNavComponent = MobileMenu
        curNavMode = navModes.mobile
      } else {
        curNavComponent = DesktopMenu
        curNavMode = navModes.desktop
      }

      initNavComponent()
    }
  }

  /**
   * Run init function of current menu UI component
   */
  const initNavComponent = () => {
    try {
      curNavComponent?.init()
    } catch (e) {
      console.error(e)
    }
  }

  /**
   * Run kill function of previous menu UI component to remove event listeners etc
   */
  const killNavComponent = () => {
    try {
      curNavComponent?.kill()
    } catch (e) {
      console.error(e)
    }
  }

  return {
    init: () => {
      initViewportSizeListener()
      handleViewportChange()
    },
    // Public function to force close any open menus (i.e. on page transition etc)
    closeMenu: () => {
      try {
        curNavComponent?.closeMenu()
      } catch (e) {
        console.error(e)
      }
    },
  }
})()

export default Header
